'use strict';

import angular from 'angular';
import ActivateController from './activate.controller';

export default angular.module('bfastCaptureManagerApp.activate', [])
  .controller('ActivateController', ActivateController)
  .name;



// WEBPACK FOOTER //
// ./client/app/account/activate/index.js